import { Icon } from "@chakra-ui/react";

export const CategoryDropdownIcon = (props) => (
  <Icon width="6" height="6" fill="none" {...props}>
    <path
      fill="#D11243"
      stroke="#D11243"
      strokeWidth=".5"
      d="M8.164.51H1.42c-.422 0-.766.397-.766.884v5.233c0 .487.344.884.766.884h6.744c.422 0 .766-.397.766-.884V1.394c0-.487-.344-.884-.766-.884Zm.205 5.665c0 .306-.217.556-.483.556H1.993c-.265 0-.482-.25-.482-.556v-4.51c0-.306.217-.556.482-.556h5.9c.265 0 .482.25.482.557v4.509h-.006Z"
    />
    <path
      fill="#000"
      stroke="#000"
      strokeWidth=".5"
      d="M8.164 11.49H1.42c-.422 0-.766.396-.766.883v5.233c0 .487.344.883.766.883h6.744c.422 0 .766-.396.766-.883v-5.233c0-.487-.344-.883-.766-.883Zm.205 5.664c0 .306-.217.556-.483.556H1.993c-.265 0-.482-.25-.482-.556v-4.51c0-.306.217-.556.482-.556h5.9c.265 0 .482.25.482.557v4.509h-.006ZM20.247.51h-6.744c-.422 0-.766.397-.766.884v5.233c0 .487.344.884.766.884h6.744c.422 0 .766-.397.766-.884V1.394c0-.487-.344-.884-.766-.884Zm.205 5.665c0 .306-.217.556-.483.556h-5.893c-.265 0-.482-.25-.482-.556v-4.51c0-.306.217-.556.482-.556h5.9c.265 0 .482.25.482.557v4.509h-.006ZM20.247 11.49h-6.744c-.422 0-.766.396-.766.883v5.233c0 .487.344.883.766.883h6.744c.422 0 .766-.396.766-.883v-5.233c0-.487-.344-.883-.766-.883Zm.205 5.664c0 .306-.217.556-.483.556h-5.893c-.265 0-.482-.25-.482-.556v-4.51c0-.306.217-.556.482-.556h5.9c.265 0 .482.25.482.557v4.509h-.006Z"
    />
  </Icon>
);
